export default __webpack_public_path__ + "static/media/logo.757432ee.jpg";